module.exports = fox._r("fonts/ropasoftpro-extrabolditalic-webfont.ttf", __webpack_public_path__ + "fonts/3FIXTyr.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/ropasoftpro-extrabolditalic-webfont.ttf
// module id = 959
// module chunks = 4